import { useEffect, useRef, useState } from 'react';
import { isPlatformRootMember } from './memberConstants';

const ACTIONS = [
  { key: 'refresh', label: '數據更新' },
  { key: 'inviterTree', label: '查看上下級' },
  { key: 'agent', label: '修改代理資訊', platformRootBlocked: true },
  { key: 'loginPassword', label: '修改登入密碼' },
  { key: 'tradePassword', label: '修改交易密碼' },
  { key: 'withdrawableProfit', label: '修改可提盈利' },
  { key: 'turnover', label: '修改流水' },
  { key: 'remark', label: '修改備註' },
  { key: 'balance', label: '修改餘額' },
  { key: 'withdrawAddress', label: '提現地址列表' },
  { key: 'memberLevel', label: '修改用戶層級' },
  { key: 'passwordless', label: '免密登入', platformRootBlocked: true },
  { key: 'violationHistory', label: '違規歷史紀錄' },
  { key: 'mute', label: '禁言', danger: true, platformRootBlocked: true },
  { key: 'disable', label: '禁用', danger: true, platformRootBlocked: true },
  { key: 'banOrder', label: '禁止下單', danger: true, platformRootBlocked: true },
];

export default function MemberActionsMenu({ row, onAction }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);
  const platformRoot = isPlatformRootMember(row?.id);

  useEffect(() => {
    function handleClickOutside(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  function handleSelect(actionKey) {
    setOpen(false);
    onAction?.(actionKey, row);
  }

  const visibleActions = ACTIONS.filter((action) => !platformRoot || !action.platformRootBlocked);

  return (
    <div className="member-actions-menu" ref={rootRef}>
      <button type="button" className="btn btn-link btn-sm" onClick={() => setOpen((v) => !v)}>
        更多 ▾
      </button>
      {open ? (
        <div className="member-actions-menu__panel">
          {visibleActions.map((action) => (
            <button
              key={action.key}
              type="button"
              className={`member-actions-menu__item ${action.danger ? 'is-danger' : ''}`}
              onClick={() => handleSelect(action.key)}
            >
              {action.label}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
